export const CHECKLIST_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.CheckList.CheckListInvalidated";
